import React from 'react'
import ReactDOM from 'react-dom/client'

import { SchoolDetail } from '../pages/school'

import '../pages/school/style.less'
const rootEl = document.getElementById('root')
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl)
  root.render(
    <React.StrictMode>
      <SchoolDetail />
    </React.StrictMode>
  )
}
